// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"ba62a2b0","323":"5d267c89","411":"92dfbdc4","482":"a63e8732","639":"4099d686","652":"3c0fe3ae","894":"15f4b288","921":"cb838443"}[chunkId] + ".chunk.js";
};